// extracted by mini-css-extract-plugin
export var addButton = "_p1-0";
export var border = "_p1-8";
export var check = "_p1-h";
export var danger = "_p1-6";
export var dropdownContainer = "_p1-1";
export var editModalBody = "_p1-j";
export var footerContainer = "_p1-i";
export var fullWidth = "_p1-a";
export var hide = "_p1-9";
export var icon = "_p1-3";
export var input = "_p1-7";
export var inputFlex = "_p1-b";
export var inputWrapper = "_p1-c";
export var manualFocus = "_p1-5";
export var optionButton = "_p1-4";
export var pillWrapper = "_p1-e";
export var pointer = "_p1-2";
export var showOverflow = "_p1-f";
export var tagsFlex = "_p1-d";
export var xButton = "_p1-g";